'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EPIC_END = exports.EPIC_END = '@@redux-observable/EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/cjs/EPIC_END.js
// module id = 757
// module chunks = 168707334958949